import { isIOS, isMobile, isSafari } from 'react-device-detect';

export const POST_LOGIN_DOWNLOAD_PROMPT_KEY = 'postLoginDownload';
export const PWA_INSTALLED_KEY = 'isInstalledLocally';
export const PROMPT_SHOW_MAX = 3;
export const PENDO_EVENT_DOWNLOAD = 'downloaded_the_source';

export const userOnIOSSafari = isMobile && isIOS && isSafari;
export const userOnIOSNotSafari = isMobile && isIOS && !isSafari;
